
import './navigation.scss';
import { Sine } from 'gsap';
import scrollTo from 'gsap/ScrollToPlugin';


export default class Navigation {

    constructor(){

        this.scrollPoss = 0;
        this.showTopBar = true;
        this.isMenuOpen = false;

        

        this.heroHeight = (document.getElementsByClassName('hero').length>0) ? document.getElementsByClassName('hero')[0].getBoundingClientRect().height : 0;

        console.log(this.heroHeight)
        if(this.heroHeight){
            window.addEventListener('scroll', this.onScroll);
            this.showTopBar = false;
        }
        
        document.getElementsByClassName('navigation--hamburger')[0].addEventListener('click', this.onMenuToggle);

        const $elems = document.querySelectorAll('a')
        let elems = Array.from($elems);
       

        elems.map(a => {
            a.onclick = (e) => {
                 // internal link
                
                if(a.getAttribute("href").substr(0,2) === '/#'){

                    // already on front page...
                    let el = document.getElementById(a.hash.substr(1));
                    // console.log(a.hash.substr(1));
                    if(el){
                        e.preventDefault();
                        this.onMenuToggle(null, false);
                        
                        // console.log(a.hash);
                        // console.log(document.getElementById(a.hash.substr(1)));
                        TweenLite.to(window, 0.5,  { scrollTo: { y: a.hash, autoKill: false }, ease:Sine.easeInOut});
                        // TweenLite.to(window, 0.5, {scrollTo:a.hash, ease:Sine.easeInOut});
                        return;
                    }
                } else {
                    // external link open in new window
                    // e.preventDefault();
                    // window.open(a.href);
                } 
            }
        })
    }

    onScroll = (e) => {
        this.scrollPoss = window.pageYOffset;
        
        // console.log(this.scrollPoss, this.heroHeight);
        if(this.scrollPoss>this.heroHeight){
            if(this.showTopBar===false){
                //remove class hide.
                // console.log(this.scrollPoss);
                document.getElementsByClassName('main-nav main-nav--flying')[0].classList.add("show");
            }
            this.showTopBar= true;
        }else {
            if(this.showTopBar===true){
                // add class hide
                document.getElementsByClassName('main-nav main-nav--flying')[0].classList.remove("show");
            }
            this.showTopBar= false;
        }
    }

    onMenuToggle = (event, showMenu) => {
        this.isMenuOpen = (showMenu === undefined) ? !this.isMenuOpen : showMenu;
        if(this.isMenuOpen){
            document.getElementsByClassName('navigation--icon')[0].classList.add('open');
            document.getElementsByClassName('navigation--flyout')[0].classList.add('open');
            document.getElementsByTagName('body')[0].classList.add('hide');
            // document.addEventListener('click', this.onMenuToggle);
        }else {
            document.getElementsByClassName('navigation--icon')[0].classList.remove('open');
            document.getElementsByClassName('navigation--flyout')[0].classList.remove('open');
            document.getElementsByTagName('body')[0].classList.remove('hide');
            // document.removeEventListener('click', this.onMenuToggle);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/navigation/navigation.js